import { ReactComponent as Complete } from '@/assets/svgs/complete.svg'
import { ReactComponent as DeFlag } from '@/assets/svgs/flag-de.svg'
import { ReactComponent as EnFlag } from '@/assets/svgs/flag-en.svg'
import { ReactComponent as FrFlag } from '@/assets/svgs/flag-fr.svg'
import { ReactComponent as ItFlag } from '@/assets/svgs/flag-it.svg'
import { ReactComponent as SaFlag } from '@/assets/svgs/flag-sa.svg'
import { ReactComponent as Home } from '@/assets/svgs/home.svg'
import { ReactComponent as Incomplete } from '@/assets/svgs/incomplete.svg'
import { ReactComponent as NotExecuted } from '@/assets/svgs/not-executed.svg'
import { ReactComponent as Patients } from '@/assets/svgs/patients.svg'
import { IMenuItem, IMenuItemMobile } from '@/types'

export const menuItems: IMenuItem[] = [
  {
    titleKey: 'gui.general.dashboard',
    url: '/',
    roles: ['patient', 'doctor'],
    show: true
  },
  {
    titleKey: 'gui.general.patients',
    url: '/patients',
    roles: ['doctor'],
    show: true
  }
]

export const menuItemsMobile: IMenuItemMobile[] = [
  {
    icon: Home,
    url: '/',
    roles: ['patient', 'doctor'],
    show: true
  },
  {
    icon: Patients,
    url: '/patients',
    roles: ['doctor'],
    show: true
  }
]

export const minLettersAlphabet = 'abcdefghijklmnopqrstuvwxyz'

export const simpleDateFormat = 'dd/MM/yyyy'
export const monthDayDateFormat = 'MMM d'
export const weekDayDateFormat = 'EEEE do'
export const fullDateFormat = 'y-MM-dd'
export const dateOnlyFormat = 'yyyy-MM-dd'

export const genderMap = {
  M: 'male',
  F: 'female',
  NA: 'not_specified'
}

export const scheduleDaysDefault = 7

export const scheduleDaysLength = {
  min: 1,
  max: 12
}

export const templateDaysLength = {
  min: 1,
  max: 12
}

export const scheduleDuration = {
  min: 1,
  max: 366
}

export const draggableItemTypes = {
  EXERCISE: 'exercise'
}

export const populateExercisesOrder: { [key: string]: number } = {
  'stand-up': 1,
  'lying-down': 2
}

export const speedValues: { [key: number]: string } = {
  1: 'slow',
  2: 'normal',
  3: 'fast'
}

export const mobileBreakpoint = '(max-width: 767px)'
export const mobileSmBreakpoint = '(max-width: 480px)'

export const maxContainerWidth = '1600px'

export const scheduleCarouselBreakpoints = [
  {
    breakpoint: 1500,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6
    }
  },
  {
    breakpoint: 1350,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5
    }
  },
  {
    breakpoint: 1150,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4
    }
  },
  {
    breakpoint: 900,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
  {
    breakpoint: 700,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  },
  {
    breakpoint: 500,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
]

export const finishStateMap = {
  completed: {
    icon: Complete
  },
  interrupted: {
    icon: Incomplete
  },
  'not-started': {
    icon: NotExecuted
  }
}

export const supportedLanguages = [
  {
    code: 'en',
    trKey: 'gui.general.english',
    icon: EnFlag
  },
  {
    code: 'fr',
    trKey: 'gui.general.french',
    icon: FrFlag
  },
  {
    code: 'it',
    trKey: 'gui.general.italian',
    icon: ItFlag
  },
  {
    code: 'de',
    trKey: 'gui.general.german',
    icon: DeFlag
  },
  {
    code: 'ar',
    trKey: 'gui.general.arabic',
    icon: SaFlag
  }
]

export const availableAudioLanguages = ['en', 'fr']

export const scheduleTemplateVariant = 'scheduleTemplate'

export const stickyStyle = {
  position: 'sticky',
  top: '64px',
  background: '#fff',
  paddingTop: '10px',
  paddingBottom: '20px',
  paddingLeft: '20px',
  paddingRight: '20px',
  maxWidth: '1576px',
  width: 'calc(100vw - 40px)',
  transform: 'translateX(-50%)',
  zIndex: 13,
  marginLeft: '50%'
}

export const scoresToValue = {
  g: 10,
  f: 8,
  b: 6
}

export const newUsersMinAge = 18
export const scheduleMaxCalendarDurationInDays = 365
